export enum Filters {
  search = "search",
  location = "location",
  industry = "industry",
  organisation = "organisation",
  country = "country",
  isRemote = "is-remote",
  page = "page",
  jobExpired = "job-expired",
  similar = "similar",
}
